<template>
  <de-layout-content>
    <div slot="header" class="spcBt">
      <span class="tit">动作库</span>
    </div>
    <div class="mb10">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd">新增动作</el-button>
    </div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="ant-advanced-search-form">
      <el-form-item label="动作名称" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入动作名称" style="width: 160px"
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
      <!-- <el-form-item label="添加人" prop="createBy">
          <el-input v-model="queryParams.createBy" placeholder="请输入添加人" style="width: 160px" @keyup.enter.native="handleQuery"></el-input>
        </el-form-item> -->
      <el-form-item label="状态:" prop="isEnable">
        <el-select v-model="queryParams.isEnable" placeholder="状态选择" clearable style="width: 180px">
          <el-option v-for="(item, index) in status" :key="index" :label="item.name" :value="item.value" />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="添加人角色:" prop="userStatus">
          <el-select v-model="queryParams.userStatus" placeholder="请选择添加人角色" clearable style="width: 180px">
            <el-option v-for="(item, index) in roles" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" element-loading-text="加载中" :data="list">
      <el-table-column label="序号" align="center" type="index" width="80" />
      <el-table-column label="动作名称" align="center" prop="name" />
      <el-table-column label="状态" align="center" prop="isEnable">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isEnable" :active-value="1" :inactive-value="0"
            @change="_switchEnable(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="动作分类" align="center" prop="type">
        <template slot-scope="scope">
          {{ typeObj[scope.row.type] }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="添加人角色" align="center" prop="position">
          <template slot-scope="scope">
            {{ positionObj[scope.row.position] }}
          </template>
        </el-table-column>
        <el-table-column label="添加人" align="center" prop="createBy"/>
        <el-table-column label="所属组织" align="center" prop="organizationName"/> -->
      <el-table-column label="添加时间" align="center" prop="createTime">
        <template slot-scope="scope">
          {{ moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total > queryParams.pageSize" :total="total" :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize" @pagination="_getList" />

    <!-- 添加或修改动作库对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="editForm" v-if="open" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="动作名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入动作名称" style="width: 320px" />
        </el-form-item>
        <el-form-item label="动作分类:" prop="type">
          <el-select v-model="form.type" placeholder="请选择动作分类" clearable style="width: 320px">
            <el-option v-for="(item, index) in types" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="isEnable">
          <el-switch v-model="form.isEnable" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="open = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

  </de-layout-content>
</template>

<script>
import moment from "moment";
import * as API_System from "@/api/train/system";


export default {
  components: {
  },
  data() {
    return {
      queryParams: {
        name: null,
        createBy: null,
        // userStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      status: [
        { name: '全部', value: null },
        { name: '启用', value: 1 },
        { name: '关闭', value: 0 }
      ],
      roles: [
        { name: '全部', value: null },
        { name: '系统管理员', value: 4 },
        { name: '体能教练', value: 1 },
        { name: '战术教练', value: 3 },
      ],
      types: [
        { name: '体能', value: 1 },
        { name: '战术', value: 3 },
        { name: '技术', value: 2 },
      ],
      typeObj: {
        1: "体能",
        2: "技术",
        3: "战术",
      },
      positionObj: {
        1: "体能教练",
        2: "技术教练",
        3: "战术教练",
        4: "系统管理员",
      },
      list: [],
      loading: false,
      total: 0,

      form: {
        name: null,
        type: null,
        isEnable: 1,
      },
      title: '',
      open: false,
      rules: {
        name: [{ required: true, message: "请输入动作名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择动作分类", trigger: "change" }],
        isEnable: [{ required: true }]
      },
    };
  },
  methods: {
    moment,
    _getList() {
      this.loading = true;
      API_System.actList(this.queryParams).then((res) => {
        // console.log(res);
        this.total = res.data.total;
        this.list = res.data.list;
        setTimeout(() => {
          this.loading = false
        }, 500);
      });
    },
    getMenuTreeselect() {
      API_System.treeSelect().then(res => {
        console.log(res);
      })
    },
    handleQuery() {
			this.queryParams.pageNum = 1;
			this._getList();
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
			this.handleQuery();
    },
    handleAdd() {
      this.open = true;
      this.title = "新建动作库";
      // 清除校验和重置表单
      this.form = {
        name: null,
        type: null,
        isEnable: 1,
      }
      // this.$refs.editForm.resetFields();
    },
    handleDel(e) {
      this.$confirm(`确定删除该动作库？`, "提示", {
        cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
        })
        .then(() => {
          this._delAct(e)
        })
        .catch(() => {});
    },
    handleEdit(e) {
      this.form = JSON.parse(JSON.stringify(e))
      this.open = true;
      this.title = "编辑动作库";
    },
    _switchEnable(e) {
      console.log(e);
      const params = {
        id: e.id,
        name: e.name,
        type: e.type,
        isEnable: e.isEnable,
      };
      API_System.editAction(params).then((res) => {
        console.log(res);
        this.$message.success( '操作成功');
        this.open = false
        this.handleQuery()
      });
    },
    submitForm() {
      console.log(this.form);
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this._editAct()
        } else {
          console.log('error submit!!');
          this.$message({
            message: '填写数据不全或数据有误',
            type: 'error'
          });
          return false;
        }
      });
    },
    _editAct() {
      let params = this.form
      let key = params.id ? 'editAction' : 'addAction'
      API_System[key](params).then((res) => {
        console.log(res);
        this.$message.success( params.id ? "编辑成功" : '添加成功');
        this.open = false
        this.handleQuery()
      });
    },
    _delAct(e) {
      console.log(e);
      API_System.delAction({ids: [e.id]}).then(res => {
        console.log(res);
        this.$message({ message: "已删除" });
        this.open = false;
        this.handleQuery()
      })
    },
  },
  created() {
    this._getList()
  },
};
</script>
<style lang='less' scoped>
</style>
